import React, { useEffect, useWindowDimensions } from 'react';
import '../Global.css';
import axios from 'axios';
import { useNavigate } from 'react-router';
import Fancy from './onboarder/Fancy';
import { useParams } from 'react-router-dom';

export default function Onboarding() {
  const { id } = useParams();

  useEffect(() => {
    document.title = 'Onboarding :: Productions.com';
  }, []);

  return (
    <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="space-y-12">
        <div className="border-b border-gray-900/10 pb-12">
          <Fancy id={id} />
        </div>
      </div>
    </div>
  );
}
